import React, { useEffect, useState } from "react";
import Http from "../../Http";
import { AdBanner_API } from "../../Helper";
import AdBanner from "./AdBanner";

const BrandSpotlight = () => {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const data = await Http.get(AdBanner_API);
        const bannerList = data?.banners || [];

        // ✅ fetch Brand Spotlight (display_order = 2)
        const spotlightBanner = bannerList.find(
          (b) =>
            b.page_url === "home" && String(b.display_order) === "2"
        );

        setBanner(spotlightBanner || null);
      } catch (error) {
        console.error("Error fetching spotlight banner:", error);
      }
    };

    fetchBanner();
  }, []);

  return (
    <section className="md:pt-24 sm:pt-10 pt-10 lg:pt-32 bg-center bg-cover">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-10">

          {/* Right: Dynamic Image */}
          <div className="w-full lg:w-1/2 flex justify-center">
            <AdBanner displayOrder="2" />
          </div>

          {/* Left: Fixed title, Dynamic h1 + p */}
          <div className="w-full lg:w-1/2 text-center lg:text-left">
            <div className="border border-indigo-600 p-1 w-60 mx-auto lg:mx-0 rounded-full flex items-center justify-center mb-4">
              <span className="text-lg font-medium text-gray-900">
                Brand Spotlight {/* fixed */}
              </span>
            </div>

            <h1 className="font-bold text-3xl md:text-5xl text-gray-900 leading-[30px] mb-5">
              {banner?.img_title }
            </h1>

            <p className="text-lg font-normal leading-7 text-gray-500 mb-4">
              {banner?.img_desc }
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default BrandSpotlight;



// import React, { useEffect, useState } from "react";
// import Http from "../../Http";
// import { AdBanner_API } from "../../Helper";
// import AdBanner from "./AdBanner";

// const BrandSpotlight = () => {
//   const [banner, setBanner] = useState(null);

//   useEffect(() => {
//     const fetchBanner = async () => {
//       try {
//         const data = await Http.get(AdBanner_API);
//         const bannerList = data?.banners || [];

//         const spotlightBanner = bannerList.find(
//           (b) =>
//             b.page_url === "home" && String(b.display_order) === "1"
//         );

//         setBanner(spotlightBanner || null);
//       } catch (error) {
//         console.error("Error fetching spotlight banner:", error);
//       }
//     };

//     fetchBanner();
//   }, []);

//   return (
//     <section className="md:pt-24 sm:pt-10 pt-10 lg:pt-32 bg-center bg-cover">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex flex-col-reverse lg:flex-row items-center gap-10">

//           {/* Right: Dynamic Image */}
//           <div className="w-full lg:w-1/2 flex justify-center">
//             <AdBanner displayOrder="2" />
//           </div>

//           {/* Left: Fixed title, Dynamic h1 + p */}
//           <div className="w-full lg:w-1/2 text-center lg:text-left">
//             <div className="border border-indigo-600 p-1 w-60 mx-auto lg:mx-0 rounded-full flex items-center justify-center mb-4">
//               <span className="text-lg font-medium text-gray-900">
//                 Brand Spotlight {/* fixed */}
//               </span>
//             </div>

//             <h1 className="font-bold text-3xl md:text-5xl text-gray-900 leading-[30px] mb-5">
//               {banner?.img_title || "Default Heading"}
//             </h1>

//             <p className="text-base font-normal leading-7 text-gray-500 mb-8">
//               {banner?.img_desc || "Default description goes here."}
//             </p>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default BrandSpotlight;
